import { render } from "./Payment_proposal_validation.vue?vue&type=template&id=23257efd&scoped=true"
import script from "./Payment_proposal_validation.vue?vue&type=script&lang=js"
export * from "./Payment_proposal_validation.vue?vue&type=script&lang=js"

import "./Payment_proposal_validation.vue?vue&type=style&index=0&id=23257efd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23257efd"]])

export default __exports__